import { client } from '../amplify-client';

export interface AdressTreffer {
  label: string;
  strasse: string;
  plz: string;
  ort: string;
  region: string;
  lat: number;
  lng: number;
}

/**
 * Adress-Autovervollständigung (Bauphase 3). Läuft über die Custom-Query
 * `adresseSuchen`, die serverseitig Amazon Location Service abfragt — bewusst
 * NICHT direkt aus dem Browser: `@aws-sdk/client-location` lässt sich wegen
 * node-only Fallback-Credential-Providern nicht sauber für den Browser
 * bündeln (siehe amplify/functions/karte-daten/handler.ts).
 */
export async function sucheAdresse(text: string): Promise<AdressTreffer[]> {
  if (text.trim().length < 3) return [];
  const { data, errors } = await client.queries.adresseSuchen({ text });
  if (errors?.length) throw new Error(errors[0]?.message ?? 'Adresssuche fehlgeschlagen.');
  return (data ?? []).filter(Boolean) as AdressTreffer[];
}
